/* Setup + care page (sections/setup-care.liquid).
   Tabs, tap-a-lamp setup videos, the per-piece care card, and links like
   #care, #care-lamps and #guide-mocha. */
(function () {
  const root = document.querySelector('[data-sc]');
  if (!root) return;

  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const replay = (el, cls) => { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };

  /* Keep the tabs just under the theme's sticky header, whatever its height. */
  const header = document.querySelector('.section-header');
  const setTop = () => root.style.setProperty('--sc-top', (header ? header.offsetHeight : 0) + 'px');
  setTop();
  if (header && window.ResizeObserver) new ResizeObserver(setTop).observe(header);

  const bar = $('[data-sc-bar]');
  const onScroll = () => bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= (header ? header.offsetHeight : 0) + 1);
  addEventListener('scroll', onScroll, { passive: true });

  /* Scrolling before the page has loaded gets reset, so wait for it. */
  if (/^#(guide|care)-/.test(location.hash)) history.scrollRestoration = 'manual';
  const whenLoaded = (fn) => (document.readyState === 'complete' ? requestAnimationFrame(fn) : addEventListener('load', () => setTimeout(fn, 50), { once: true }));
  const ready = () => root.classList.contains('is-ready');

  /* ---------- tabs ---------- */
  const tablist = $('[role=tablist]');
  const tabs = { setup: $('#sc-tab-setup'), care: $('#sc-tab-care') };
  const panels = { setup: $('#sc-setup'), care: $('#sc-care') };

  function showTab(name, { focus = false, hash = true } = {}) {
    const changed = panels[name].hidden;
    for (const k in tabs) {
      const on = k === name;
      tabs[k].setAttribute('aria-selected', on);
      tabs[k].tabIndex = on ? 0 : -1;
      panels[k].hidden = !on;
    }
    tablist.dataset.active = name;
    if (changed && ready()) replay(panels[name], 'sc-enter');
    if (focus) tabs[name].focus();
    if (hash) history.replaceState(null, '', name === 'care' ? '#care' : location.pathname + location.search);
    if (name !== 'setup') $$('video').forEach((v) => v.pause());
  }

  const backToTabs = () => {
    const hero = $('.sc-hero');
    const top = hero.getBoundingClientRect().bottom + scrollY - (header ? header.offsetHeight : 0);
    if (scrollY > top) window.scrollTo({ top, behavior: 'instant' });
  };
  for (const k in tabs) tabs[k].addEventListener('click', () => { showTab(k); backToTabs(); });
  tablist.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    showTab(tablist.dataset.active === 'setup' ? 'care' : 'setup', { focus: true });
  });

  /* ---------- set up: tap a lamp to open its card ---------- */
  const empty = $('[data-sc-empty]');
  const setupChips = $('[data-sc-setup-chips]');

  function showGuide(id, { scroll = 'smooth', play = true } = {}) {
    const guide = $('#guide-' + id);
    if (!guide) return;
    $$('[data-guide]', setupChips).forEach((c) => {
      const on = c.dataset.guide === id;
      c.setAttribute('aria-pressed', on);
      if (on) setupChips.scrollTo({ left: setupChips.scrollLeft + c.getBoundingClientRect().left - setupChips.getBoundingClientRect().left - 16, behavior: 'smooth' });
    });
    $$('.sc-guide').forEach((g) => {
      if (g !== guide) g.querySelector('video')?.pause();
      g.hidden = g !== guide;
    });
    if (empty) empty.hidden = true;
    replay(guide, 'sc-enter');
    history.replaceState(null, '', '#guide-' + id);

    const player = guide.querySelector('.sc-player');
    if (player) {
      let video = player.querySelector('video');
      if (!video) {
        video = document.createElement('video');
        Object.assign(video, { controls: true, playsInline: true, muted: true, preload: 'metadata' });
        video.setAttribute('playsinline', '');
        if (guide.dataset.poster) video.poster = guide.dataset.poster;
        for (const [url, type] of [[guide.dataset.hls, 'application/x-mpegURL'], [guide.dataset.mp4, 'video/mp4']]) {
          if (!url) continue;
          const source = document.createElement('source');
          source.src = url;
          source.type = type;
          video.append(source);
        }
        player.append(video);
      }
      if (play) video.play().catch(() => {});
    }
    /* Keep the chips in view so another lamp is one tap away. */
    if (scroll) whenLoaded(() => setupChips.scrollIntoView({ behavior: scroll, block: 'start' }));
  }

  setupChips?.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-guide]');
    if (chip) showGuide(chip.dataset.guide);
  });

  /* ---------- care: tap a piece for its own list ---------- */
  const card = $('[data-sc-card]');
  const essentials = card.innerHTML;
  const doLabel = $('.sc-do h4', card)?.textContent || 'Do';
  const avoidLabel = $('.sc-avoid h4', card)?.textContent || 'Avoid';

  function careFor(p) {
    const m = p.mat.toLowerCase();
    const lamp = p.kind === 'lamp' || p.kind === 'pendant';
    const pla = m.includes('pla'), petg = m.includes('petg');
    const d = [], a = [], links = [];
    if (lamp && /puck/i.test(p.bulb)) d.push("Built-in LED, so there's no bulb to change.");
    else if (lamp) d.push({ key: true, t: `LED bulbs only, 3W max${p.bulb ? ` (${p.bulb} fitting)` : ''}. Yours is in the box.` });
    d.push(petg ? 'Microfibre on the shade, a soft brush for the rest.' : 'Dust with a soft, dry cloth or brush.');
    if (m.includes('metal')) d.push('Wipe the metal base with a soft, dry cloth.');
    if (p.kind === 'pendant') d.push('Check the ceiling hooks are still firm now and then.');
    if (p.kind === 'pot') d.push("Water away, it's watertight. Rinse the reservoir now and then.");
    if (p.dry) { d.push('Dried or faux flowers only.'); a.push({ key: true, t: "Water. It isn't watertight." }); }
    if (pla) a.push('Hot cars and harsh afternoon sun.');
    if (petg && !pla) a.push('Hot cars and heaters.');
    if (petg) a.push('Paper towel on the shade. It leaves fine scratches.');
    a.push(p.kind === 'pot' ? 'Outdoors, dishwashers or boiling water.' : 'Dishwashers, soaking and harsh cleaners.');
    if (pla) links.push(['PLA care', 'care-pla']);
    if (petg) links.push(['PETG care', 'care-petg']);
    if (lamp) links.push(['Bulbs and cords', 'care-lamps']);
    if (p.kind === 'pot') links.push(['Pot care', 'care-pots']);
    if (p.kind === 'vase') links.push(['Vase care', 'care-vases']);
    return { d, a, links: links.filter(([, id]) => document.getElementById(id)) };
  }

  const rows = (items, mark) =>
    '<ul class="sc-rows">' +
    items.map((i) => {
      const o = typeof i === 'string' ? { t: i } : i;
      return `<li${o.key ? ' class="is-key"' : ''}><span class="sc-mark">${mark}</span>${esc(o.t)}</li>`;
    }).join('') +
    '</ul>';

  function renderCard(chip) {
    if (!chip) { card.innerHTML = essentials; replay(card, 'sc-enter'); return; }
    const p = { name: chip.dataset.name, mat: chip.dataset.mat, bulb: chip.dataset.bulb, kind: chip.dataset.kind, dry: chip.hasAttribute('data-dry'), img: chip.dataset.img };
    const c = careFor(p);
    card.innerHTML = `
      <div class="sc-card__head">
        ${p.img ? `<img src="${esc(p.img)}" alt="" width="52" height="52">` : ''}
        <div><h3>${esc(p.name)}</h3><p>${esc(p.mat)}</p></div>
      </div>
      <div class="sc-cols">
        <div class="sc-col sc-do"><h4>${esc(doLabel)}</h4>${rows(c.d, '✓')}</div>
        <div class="sc-col sc-avoid"><h4>${esc(avoidLabel)}</h4>${rows(c.a, '✕')}</div>
      </div>
      ${c.links.length ? `<div class="sc-card__links">${c.links.map(([t, id]) => `<a class="sc-pill" href="#${id}" data-sc-open="${id}">${t} ↓</a>`).join('')}</div>` : ''}`;
    replay(card, 'sc-enter');
  }

  const careChips = $('[data-sc-care-chips]');
  careChips?.addEventListener('click', (e) => {
    const chip = e.target.closest('.sc-chip');
    if (!chip) return;
    const on = chip.getAttribute('aria-pressed') !== 'true';
    $$('.sc-chip', careChips).forEach((c) => c.setAttribute('aria-pressed', c === chip && on));
    renderCard(on ? chip : null);
  });

  /* ---------- open a care guide from anywhere, e.g. #care-lamps ---------- */
  function openCare(id, behavior = 'smooth') {
    showTab('care', { hash: false });
    history.replaceState(null, '', '#' + id);
    const d = document.getElementById(id);
    if (!d) return;
    d.open = true;
    whenLoaded(() => d.scrollIntoView({ behavior, block: 'start' }));
  }
  root.addEventListener('click', (e) => {
    const a = e.target.closest('[data-sc-open]');
    if (!a) return;
    e.preventDefault();
    openCare(a.dataset.scOpen);
  });

  /* ---------- contact form: hidden until "Still stuck?" is tapped ---------- */
  const contact = document.getElementById('ContactForm')?.closest('.shopify-section');
  const openContact = (scroll = true) => {
    if (!contact) return;
    contact.classList.add('sc-contact-open');
    if (scroll) contact.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  $('[data-sc-contact]')?.addEventListener('click', (e) => { e.preventDefault(); openContact(); });
  if (window.Shopify?.designMode) openContact(false);
  if (location.hash === '#ContactForm') { openContact(false); whenLoaded(() => contact?.scrollIntoView({ behavior: 'instant', block: 'start' })); }

  /* ---------- links: #care, #care-pla, #guide-mocha ---------- */
  function route() {
    const h = location.hash.slice(1);
    if (h === 'care') showTab('care', { hash: false });
    else if (h.startsWith('care-')) openCare(h, 'instant');
    else if (h.startsWith('guide-') && $('#' + h)) { showTab('setup', { hash: false }); showGuide(h.slice(6), { scroll: 'instant', play: false }); }
  }
  route();
  addEventListener('hashchange', route);
  whenLoaded(() => root.classList.add('is-ready'));
})();
